module.exports = __webpack_public_path__ + "static/media/TC.5532d600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TC.svg
// module id = 369
// module chunks = 0